var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgUserinline = function SvgUserinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.02 13.438c3.579 0 6.48-2.897 6.48-6.47C18.5 3.397 15.6.5 12.02.5 8.442.5 5.54 3.396 5.54 6.969c0 3.572 2.903 6.468 6.48 6.468Zm0-11.5c2.78 0 5.04 2.256 5.04 5.03A5.039 5.039 0 0 1 12.02 12a5.039 5.039 0 0 1-5.04-5.031 5.04 5.04 0 0 1 5.04-5.032Zm4.28 12.937H7.7c-3.976 0-7.2 3.218-7.2 7.188 0 .793.645 1.437 1.4 1.437h20.2c.795 0 1.4-.644 1.4-1.438.04-3.97-3.182-7.187-7.2-7.187ZM1.94 22.063c0-3.171 2.584-5.75 5.76-5.75h8.6c3.217 0 5.8 2.578 5.8 5.75H1.94Z",
    fill: "#250002"
  })));
};

export default SvgUserinline;